export default __webpack_public_path__ + "static/media/gallery_17.ad34bf07.jpg";